let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("4ZBya")).then(() => parcelRequire('6EfBC'));